import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { GET_COURT_RECORDINGS_QUERY_KEY } from "./useListCourtRecordings";
import { translate } from "../../../i18n";

export const useDeleteCourtRecording = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationKey: ['deleteCourtRecording'],
        mutationFn: (id: string) =>
            client.fetchApi<{ success: boolean }, {}>({
                endpoint: `court-recordings/${id}`,
                method: 'DELETE',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_COURT_RECORDINGS_QUERY_KEY(organizationId) });
            toast({ title: translate('court_recording.recording_deleted'), status: 'success', duration: 2000 });
        },
        onError: (err) => {
            toast({
                title: translate('court_recording.delete_failed'),
                description: err instanceof Error ? err.message : undefined,
                status: 'error',
            });
        },
    });
};
